export default __webpack_public_path__ + "static/media/H4010.2.5edeb121.mp3";